
import { useEffect, useState } from 'react';

export function useCountdown(
  seconds,
  onExpired,
  warningSeconds,
  warningExpirationHandler,
) {
  // Initialize timeLeft with the seconds prop.
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    // Exit early when we reach 0.
    if (!timeLeft) {
      onExpired();
      return;
    }

    if (
      warningSeconds &&
      warningExpirationHandler &&
      timeLeft === warningSeconds
    ) {
      warningExpirationHandler();
    }

    // Save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [timeLeft]);

  /**
   * Resets the timer.
   */
  function reset() {
    setTimeLeft(seconds);
  }

  return { reset, timeLeft };
}